export enum LinkCardTypes {
    Link = "-link",
    Button = "-button",
}
